import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { TextBox, formatDate, formatTime } from "../../Components/InputElements";
import { currentDateAndTime } from "../../Constants/constants";
import { NoRecords } from "../../Components/Shimmer";
import { decodeData } from "../../Constants/constants";
class NewPayroll extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      filter_employee_id: '',
      employee_attendance_id: 0,
      punch_in_datetime: "",
      punch_out_datetime: "",
      employee_attendence_remark: "",
      from_date: '',
      to_date: '',
      selectOption: "",
      location_id: '',
      department_id: '',
      Department: [],
      Location: [],
      employee_verified_row: [],
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      selectedEmployeeId: null,
      selectedRows: [],
      loadingPost: false,
      regularizeModal: false,
      decodedData: [],
      location_options: [],
      designation_id:'',

    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetDepartmentMasters();
      this.GetLocationMasters();
      this.GetEmployeesVerifiedList();
      this.GetList();
      this.GetEmploymentMasterList();

    });
  }
  
  componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
        }
  formatGetedDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  GetInfo = (row) => {
    // const { apiURL, apiHeaderJSON } = this.context;
    // const headers = apiHeaderJSON;
    // axios.get(`${apiURL}Attendance/GetEmployeeAttendanceInfo`, {
    //   params: {
    //     employee_attendance_id: this.state.employee_attendance_id,
    //     employee_id: this.state.employee_id,
    //   }, headers
    // }).then((response) => {
    //   const { data, success } = response.data;
    //   if (success === true) {
    //     const punchInDateTime = data[0].punch_in_datetime;
    //     const punchOutDateTime = data[0].punch_out_datetime;

    //     // Format punch_in_datetime
    //     const formattedPunchInDateTime = this.formatGetedDateTime(punchInDateTime);

    //     // Format punch_out_datetime only if it's not null
    //     let formattedPunchOutDateTime = null;
    //     if (punchOutDateTime !== null) {
    //       formattedPunchOutDateTime = this.formatGetedDateTime(punchOutDateTime);
    //     }

    //     this.setState({
    //       punch_in_datetime: formattedPunchInDateTime,
    //       punch_out_datetime: formattedPunchOutDateTime
    //     });
    //   }
    // }).catch((error)=>{
    //   console.log(error);
    // }).finally(this.setState({ loadingInfo:false,}));
    this.setState({
      selectedRows: [
        {
            employee_id: row?.employee_id,
            employee_name: row?.employee_name,
            employee_code: row?.employee_code,
        },
      ],
      punch_in_datetime: `${currentDateAndTime()?.split(" ")[0]} 10:00:00`,
      punch_out_datetime: `${currentDateAndTime()?.split(" ")[0]} 19:00:00`,
      loadingInfo:false,
    });
  }

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };

  GetEmployeesVerifiedList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_verified_row: data.data.map((row) => ({
              value: row.employee_id,
              label: row.employee_name
            }))
          }));
        }
      });
  }



  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  // GetList = () => {
  //   const { apiURL, apiHeaderJSON } = this.context;
  //   const headers = apiHeaderJSON;

  //   axios
  //     .get(`${apiURL}Employees/GetEmployeesByShift`, {
  //       params: {
  //         limit: this.state.limit,
  //         page: this.state.page,
  //         department_id: this.state.department_id,
  //         location_id: this.state.location_id,
  //         from_date: this.state.from_date,
  //         to_date: this.state.to_date,
  //         employee_id: this.state.filter_employee_id,
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       var data = response.data;
  //       if (response.data.success === true) {
  //         this.setState({
  //           rows: data.data,
  //           next: data.next,
  //           prev: data.prev,
  //           page: data.page,
  //           total_records: data.total_records,
  //           total_pages: data.total_pages,
  //           loadingList: false,
  //         });
  //       } else {
  //         this.setState({ loadingList: false });
  //       }
  //     });
  // };
  getLocationFilterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
      axios.get(`${apiURL}Payrolls/GetLocations`,
          {
              params: {
                  date: currentDateAndTime()
              }
              , headers
          }).then(async (response) => {
              var data = response.data;
              // console.log("getLocationFilterList", data);
              if (data?.success === true) {
                  let row = data?.locations?.map((val) => {
                      return { value: val?.location_id, label: val?.location_title }
                  });
                  this.setState({ 
                    locationOptions: row} ,
                    ()=>{ this.GetList() });
  
  
              } else {
                this.setState({ locationOptions: ""});
              }
          });
  };
  GetEmploymentMasterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
      .then((response) => {
        let data = response.data;
        if (response.data.success === true) {
            data= data?.data;
          this.setState((prevState) => ({
            location_options: data.location_list.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
            department_options: data?.department_list.map((row) => ({
                value: row.department_id,
                label: row.department_title,
              })),
            designation_options: data?.designation_list.map((row) => ({
                value: row.designation_id,
                label: row.designation_title,
              })),
            grade_options: data?.grade_list.map((row) => ({
                value: row.grade_id,
                label: row.grade_title,
              })),
            state_options: data?.state_list.map((row) => ({
                value: row.state_id,
                label: row.state_title,
              })),
            category_options: data?.category_list.map((row) => ({
                value: row.company_employee_category_id,
                label: row.company_employee_category,
              })),
            type_options: data?.type_list.map((row) => ({
                value: row.company_employee_type_id,
                label: row.company_employee_type,
              })),
          }));  
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployees`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          // from_date: this.state.from_date,
          // to_date: this.state.to_date,
          // employee_status: this.state.selectOption || " ",
          designation_id: this.state.designation_id || "",
          location_id: this.state.location_id || "",
          department_id: this.state.department_id || "",
          category_id: this.state.category_id || "",
          activated: this.state.excelEmployeeStatus==="All" ? null : this.state.excelEmployeeStatus,
         
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        // let departmentRow= data?.data?.map((val)=>{
        //   return { value }
        // })
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSearch: false,
         
            });
        } else {
          this.setState({ loadingList: false,loadingSearch: false });
        }
      });
  };
  
  handleInputSearch = (e) => {
    this.GetList();
  }

  // handleInputChange = (e) => {
  //   this.setState({
  //     [e.target.name]: e.target.value,
  //   });
  // };
  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      if (this.state.keyword === "") {
        this.GetList();
        this.GetEmploymentMasterList();
      }
    });
  };
  handleClearAll = () => {
    this.setState({
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      grade_id: "",
      designation_id: "",
      location_id: "",
      department_id: "",
      category_id: "",
      location_shift_id: "",
      // assigned_leave_status: "All",
      excelEmployeeStatus: "All",
      designation_id: '',
    }
      , () => {
        this.GetList();
       
      });
  };


  handleDepartmentChange = (selectedOption) => {
    this.setState({
      department_id: selectedOption.value,
    });
  };

  handleLocationChange = (selectedOption) => {
    this.setState({
      location_id: selectedOption.value,
    });
  };


  // handleCheckboxChange = (employeeId) => {
  //   this.setState((prevState) => {
  //     const selectedRows = [...prevState.selectedRows];

  //     if (selectedRows.includes(employeeId)) {
  //       selectedRows.splice(selectedRows.indexOf(employeeId), 1);
  //     } else {
  //       selectedRows.push(employeeId);
  //     }

  //     return { selectedRows };
  //   });
  // };
  handleCheckboxChange = (employeeData) => {
    console.log("employeeData",employeeData);
    const { selectedRows } = this.state;
    const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);
    
    if (isSelected) {
        this.setState({
            selectedRows: selectedRows.filter(row => row.employee_id !== employeeData?.employee_id),
        });
    } else {
        this.setState({
            selectedRows: [
                ...selectedRows,
                {
                    employee_id: employeeData?.employee_id,
                    employee_name: employeeData?.employee_name,
                    employee_code: employeeData?.employee_code,
                },
            ],
        });
    }
};
  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) =>{
          return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
        });

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    const formatDateTime = (isoDateString) => {
      const date = new Date(isoDateString);
      const formattedDate = date.toISOString().split("T")[0];
      const formattedTime = date.toTimeString().split(" ")[0];
      return `${formattedDate} ${formattedTime}`;
    };

    // Format punch_in_datetime and punch_out_datetime
    const formattedPunchInDateTime = formatDateTime(this.state.punch_in_datetime);
    const formattedPunchOutDateTime = formatDateTime(this.state.punch_out_datetime);

    // var formData = {
    //   employee_id: this.state.employee_id,
    //   employee_attendance_id: this.state.employee_attendance_id,
    //   employee_attendence_remark: this.state.employee_attendence_remark,
    //   punch_in_datetime: formattedPunchInDateTime,
    //   punch_out_datetime: formattedPunchOutDateTime,
    // };
    const formData = {
      date: currentDateAndTime(),
      employees_list: this.state.selectedRows,
      remark_by_admin: this.state.employee_attendence_remark,
      punch_in_datetime: formattedPunchInDateTime,
      punch_out_datetime: formattedPunchOutDateTime,
    };


  Swal.fire({
    title: 'Are you sure?',
    text: `Do you want to regularize the attendace?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes!',
    cancelButtonText: 'No!',
  }).then((result) => {
    if (result.isConfirmed) {
    axios.post(`${apiURL}Attendance/UpdateEmployeeAttendance`, formData, { headers })
    .then((response) => {
      const { success } = response.data;

      if (success === true) {
        this.setState({
          employee_attendance_id: 0,
          employee_id: 0,
          selectedRows:[],
          punch_in_datetime: '',
          punch_out_datetime: '',
          employee_attendence_remark: '', 
        });
        this.GetList();
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }
    });
  }});

  };

  handleSelect = (selectedOption) => {
    this.setState({
      filter_employee_id: selectedOption.value
    });
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };
  handleLimitChange = (e) => {
    this.setState({
            limit: parseInt(e.target.value),
            page: 1,
        }, ()=>{ this.GetList(); });
};

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Attendance Regularization`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="card-header">
                      <div className="row">
                        <div className='col-md-3'>
                        <label htmlFor="keyword">Search By Employee Name Or Code</label>
                          <div className="input-group">
                            <input
                              type="search"
                              className="form-control"
                              onChange={this.handleInputChange}
                              name="keyword"
                              value={this.state.keyword}
                              aria-label="Recipient's username"
                              aria-describedby="button-addon2"
                              placeholder="Search Name"
                            />
                            <button
                              className="btn btn-success"
                              disabled={this.state.loadingSearch}
                              onClick={() => {
                                if (
                                  this.state.keyword &&
                                  !this.state.loadingSearch
                                ) {
                                  this.handleInputSearch();
                                }
                              }}
                              type="button"
                              id="button-addon2"
                            >
                              {this.state.loadingSearch ? (
                                <span
                                  class="spinner-border flex-shrink-0"
                                  role="status"
                                  style={{
                                    width: "0.8rem",
                                    height: "0.8rem",
                                    borderWidth: "2px",
                                  }}
                                >
                                  <span class="visually-hidden">Loading...</span>
                                </span>
                              ) : (
                                <i className="ri-search-line"></i>
                              )}
                            </button>
                          </div>
                        </div>
                          <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                <label>Location</label>
                                <Select
                                options={this.state.location_options}
                                value={this.state.location_id ? this.state.location_options.find( (option) => option.value === this.state.location_id) : null }
                                onChange={(selectedOption) => this.handleSelectChange( "location_id", selectedOption )}
                                placeholder={`Select Location`}
                                />
                            </div>
                        </div>       
                        <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Designation</label>
                                </div>
                                <Select
                                options={this.state.designation_options}
                                value={
                                    this.state.designation_id
                                    ? this.state.designation_options.find(
                                        (option) =>
                                            option.value === this.state.designation_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "designation_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Designation`}
                                />
                            </div>
                        </div>                                        
                                               
                        {/* <div className='col-md-3'>
                          <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3'>
                          <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                        </div> */}
                        <div className="col-md-3 ">
                          <div style={{ zIndex: 6, width: "90%" }}className=" position-absolute">
                            <label htmlFor="Department" className="form-label">Department</label>
                            <Select
                              value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null}
                              options={this.state.Department}
                              onChange={this.handleDepartmentChange}
                              hint={`Select Department`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className='col-md-12' >
                          <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                            <div className="d-flex align-items-center gap-3 ">
                               
                                <div className='' >
                                <div className='col-md-1 me-3'>
                        <div>
                          <label className="noWrap">Apply Filter</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleInputSearch}
                          // disabled={!this.state.keyword && !this.state.employee_status  && !this.state.department_title && !this.state.location_title}
                          className={`btn noWrap btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.employee_status  && !this.state.department_id && !this.state.designation_id &&  !this.state.location_id)}`}>
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      </div>
                                 
                                </div>
                                <div className='col-md-1'>
                        <div>
                          <label className="noWrap">Clear Filter</label>
                        </div>
                        <button
                          type="button"
                          // disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                          className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.employee_status  && !this.state.department_id && !this.state.designation_id &&  !this.state.location_id)}`}
                          onClick={this.handleClearAll}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>Clear</button>
                      </div> 
                            </div>
                            { this.state.decodedData?.includes(3) && ( 
                            <div className="float-right">
                                <div>
                                  <label>Regularize</label>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-primary btn-label waves-effect waves-light "
                                  disabled={this.state.selectedRows.length<1}
                                  onClick={() => {  
                                    this.setState({
                                      regularizeModal:true,
                                      punch_in_datetime: `${currentDateAndTime()?.split(" ")[0]} 10:00:00`,
                                      punch_out_datetime: `${currentDateAndTime()?.split(" ")[0]} 19:00:00`,
                                    });
                                  }}
                                >
                                  <i className="ri-edit-box-line label-icon align-middle fs-16 me-2" />
                                  Regularize
                                </button>
                            </div>)}
                          </div>

                        </div>
                      </div>

                    </div>
                    <div className="">
                      <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                        <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ minWidth: "100%" }}>
                          <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                            <tr>
                              {this.state.rows?.length > 0 && this.state.decodedData?.includes(3) ?
                                  <th  style={{ width: "10%" }}>
                                      <div className=" d-flex gap-1 align-items-center justify-content-center" >
                                              <input
                                                  type="checkbox"
                                                  className="form-check-input cursorPointer"
                                                  disabled={this.state.loadingPost}
                                                  checked={this.state.selectedRows.length === this.state.rows.length}
                                                  onChange={this.handleSelectAll}
                                              />
                                          
                                          Select {this.state.selectedRows?.length>0 && <span className=' text-white'>({this.state.selectedRows?.length})</span>}

                                      </div>
                                  </th> : null
                              }
                              <th>Employee Code</th>
                              <th>Employee Name</th>
                              {/* <th className="text-center">Punch In </th>
                              <th className="text-center">Punch Out</th>
                              <th>Working Hour</th> */}
                              {/* <th className="text-center">Action</th> */}
                            </tr>
                          </thead>
                          {this.state.rows?.length===0 ? (
                            <tbody>
                              <td colSpan={5}>
                                  <NoRecords />
                              </td>
                          </tbody>):
                          (<tbody>
                            {this.state.rows.map((row) => {
                              return (
                                <tr key={row.employee_id} className={`${row.flag_issue_class}`}>
                                  {this.state.rows?.length > 0 && this.state.decodedData?.includes(3) && (
                                  <td>
                                      <div className="d-flex justify-content-center align-items-center">
                                          <input
                                              type="checkbox"
                                              className="form-check-input cursorPointer"
                                              disabled={this.state.loadingPost}
                                              checked={this.state.selectedRows.some(val => val.employee_id === row?.employee_id)}
                                              onChange={() => this.handleCheckboxChange(row)}
                                          />
                                      </div>
                                  </td>)}
                                  <td>{row.employee_code}</td>
                                  <td>{row.employee_name}</td>
                                  {/* <td>
                                    <NavLink to={`/AttendenceDashboard/${row.employee_id}`}>
                                      {row.employee_name}
                                    </NavLink>
                                  </td> */}
                                  {/* <td> <div className="d-flex justify-content-around"><span>{formatDate(row.punch_in_datetime) || ""}</span> <span>{formatTime(row.punch_in_datetime) || ""}</span></div></td>
                                  <td>
                                    <div className="d-flex justify-content-around">
                                      {row.punch_out_datetime !== " " ? (
                                        <>
                                          <span>{formatDate(row.punch_out_datetime)}</span>
                                          <span>{formatTime(row.punch_out_datetime)}</span>
                                        </>
                                      ) : (
                                        <span></span>
                                      )}
                                    </div>
                                  </td>
                                  <td>{row.working_hours}</td> */}
                                  {/* <td className='d-flex justify-content-around'>
                                    {this.state.loadingInfo==row.employee_id?
                                      (<button className="btn btn-primary btn-load">
                                          <span className="d-flex align-items-center">
                                              <span className="spinner-border flex-shrink-0" role="status">
                                                  <span className="visually-hidden">Loading...</span>
                                              </span>
                                              <span className="flex-grow-1 ms-2">
                                                  Loading...
                                              </span>
                                          </span>
                                      </button>):
                                      (<button
                                        type="button"
                                        className="btn btn-sm btn-primary btn-label waves-effect waves-light"
                                        disabled={this.state.selectedRows.length>0}
                                        onClick={() => this.setState({ regularizeModal:true, employee_id: row.employee_id, employee_attendance_id: row.employee_attendance_id,loadingInfo:`${row.employee_id}` }, (prevState) => this.GetInfo(row))}
                                      >
                                        <i className="ri-edit-box-line label-icon align-middle fs-16 me-2" />
                                        Regularize
                                      </button>)}
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>)}
                          {/* <tfoot className='table-light sticky-bottom z-1'>
                              <tr>
                                  <th colSpan={8} >
                                      <div className="d-flex justify-content-between" >
                                      <button
                                          disabled={this.state.prev === false && this.state.loadingList === false}
                                          type="button"
                                          onClick={() => this.handlePrev()}
                                          className="btn btn-warning btn-label waves-effect waves-light"
                                        >
                                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                          Previous
                                        </button>
                                        <div
                                          className="col-md-4"
                                          style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                          <small>
                                            Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}
                                          </small>
                                        </div>
                                        <div className="col-md-2">
                                          <select
                                            className="form-select"
                                            onChange={(e) => this.handleChange(e)}
                                          >
                                            {Array.from({ length: this.state.total_pages }, (_, i) => (
                                              <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                Page {i + 1}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="col-md-2">
                                          <select
                                            className="form-select"
                                            onChange={this.handleLimitChange}
                                            value={this.state.limit}
                                          >
                                            {this.state.total_records >= 1 && (
                                              <option value={this.state.total_records}>
                                                All
                                              </option>
                                            )}
                                            {limitOptions.map((option) => (
                                              <option key={option} value={option}>
                                                Limit {option}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <button
                                          disabled={this.state.next === false && this.state.loadingList === false}
                                          type="button"
                                          onClick={() => this.handleNext()}
                                          className="btn btn-primary btn-label waves-effect right waves-light"
                                        >
                                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                          Next
                                        </button>
                                      </div>
                                  </th>
                              </tr>
                          </tfoot> */}
                          
                        </table>
                      </div>
                      <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-4">
                          <button
                            disabled={
                              this.state.prev === false &&
                                this.state.loadingList === false
                                ? true
                                : false
                            }
                            type="button"
                            onClick={() => this.handlePrev()}
                            className={`btn btn-warning btn-label waves-effect waves-light`}
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                            Previous
                          </button>
                          <div
                            className="col-md-4"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {
                              <small>
                                Total Records: {this.state.total_records} |
                                Total Pages: {this.state.total_pages} |
                                Current Page: {this.state.page}
                              </small>
                            }
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-select"
                              onChange={(e) => this.handleChange(e)}
                            >
                              {Array.from(
                                { length: this.state.total_pages },
                                (_, i) => (
                                  <option
                                    selected={this.state.page === i + 1}
                                    key={i}
                                    value={i + 1}
                                  >
                                    Page {i + 1}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <div className="col-md-2">
                                    <select className="form-select" onChange={(e) => this.handleLimitChange(e)} value={this.state.limit}>
                                        {this.state.total_records >= 1 && (
                                            <option value={this.state.total_records}>
                                                All
                                            </option>
                                        )}
                                        {limitOptions?.map((option) => (
                                            <option key={option} value={option}>
                                                Limit {option}
                                            </option>
                                        ))}
                                        
                                    </select>
                                </div>
                          <button
                            disabled={
                              this.state.next === false &&
                                this.state.loadingList === false
                                ? true
                                : false
                            }
                            type="button"
                            onClick={() => this.handleNext()}
                            className={`btn btn-primary btn-label waves-effect right waves-light`}
                          >
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                            Next
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {this.state.regularizeModal && (
               <div className="modal show" id="exampleModalgrid" tabIndex={-1} >
               <div className="modal-dialog modal-lg">
                 <div className="modal-content">
                   <div className="modal-header">
                     <h5 className="modal-title" id="exampleModalgridLabel">Edited Attendence</h5>
                     <button type="button" onClick={()=> this.setState({ regularizeModal:false })} className="btn-close"  aria-label="Close" />
                   </div>
                   <div className="modal-body">
 
                     <div className="row mb-3">
                       <div className="col-md-6">
                         <label htmlFor="punch_in_datetime" className="form-label">Punch In DateTime</label>
                         <input
                           type="datetime-local"
                           id="punch_in_datetime"
                           name="punch_in_datetime"
                           className="form-control"
                           value={this.state.punch_in_datetime}
                           onChange={this.handleInputChange}
                           required={true}
                           step="1" // Allows specifying seconds if needed
                           pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                         />
                       </div>
 
                       <div className="col-md-6">
                         <label htmlFor="punch_out_datetime" className="form-label">Punch Out DateTime</label>
                         <input
                           type="datetime-local"
                           id="punch_out_datetime"
                           name="punch_out_datetime"
                           className="form-control"
                           value={this.state.punch_out_datetime}
                           onChange={this.handleInputChange}
                           required={true}
                           step="1" // Allows specifying seconds if needed
                           pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                         />
                       </div>
 
                       <div className="col-md-6 mt-3">
                         <label htmlFor="employee_attendence_remark" className="form-label">Attendence Remark</label>
                         <input
                           type="text"
                           id="employee_attendence_remark"
                           placeholder="Enter Attendence Remark"
                           name="employee_attendence_remark"
                           className="form-control"
                           value={this.state.employee_attendence_remark}
                           onChange={this.handleInputChange}
                         />
                       </div>
                     </div>
                     <div className="d-flex justify-content-end">
                       <button type="button" onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
                         <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save </button>
                     </div>
 
                   </div>
                 </div>
               </div>
             </div>)} */}
            {this.state.regularizeModal && (
               <div id="myModal" className="modal show" tabIndex={-1} style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
                aria-labelledby="myModalLabel"
                aria-hidden="true"
            >
                <div
                className=" bg-light m-auto mt-3"
                style={{ width: "40%" }}
                >
                <div className="modal-content">
                    <div
                    style={{ padding: "10px 10px 0 10px" }}
                    className="modal-header"
                    >
                        <h5 className="modal-title" id="myModalLabel">
                            Regularize Attendance
                        </h5>
                        <button
                            onClick={() => {
                              if(!this.state.loadingPost){
                                this.setState({ regularizeModal:false })
                              }
                            }}
                            className="btn-close"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div
                            style={{ padding: "10px 0px 0 0px" }}
                            className="card-body form-steps"
                        >
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <label htmlFor="punch_in_datetime" className="form-label">Punch In DateTime
                              <span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span>
                              </label>
                              <input
                                type="datetime-local"
                                id="punch_in_datetime"
                                name="punch_in_datetime"
                                className="form-control"
                                value={this.state.punch_in_datetime}
                                onChange={this.handleInputChange}
                                required={true}
                                step="1" // Allows specifying seconds if needed
                                pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                              />
                            </div>
 
                            <div className="col-md-6">
                              <label htmlFor="punch_out_datetime" className="form-label">Punch Out DateTime
                              <span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span>
                              </label>
                              <input
                                type="datetime-local"
                                id="punch_out_datetime"
                                name="punch_out_datetime"
                                className="form-control"
                                value={this.state.punch_out_datetime}
                                onChange={this.handleInputChange}
                                required={true}
                                step="1" // Allows specifying seconds if needed
                                pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                              />
                            </div>
 
                            <div className="col-md-12 mt-3">
                              <label htmlFor="employee_attendence_remark" className="form-label">Attendence Remark
                              <span
                                style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                *
                              </span>
                              </label>
                              <input
                                type="text"
                                id="employee_attendence_remark"
                                placeholder="Enter Attendence Remark"
                                name="employee_attendence_remark"
                                className="form-control"
                                value={this.state.employee_attendence_remark}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-end">
                            {!this.state.loadingPost? 
                            (<button type="button" disabled={!this.state.employee_attendence_remark} onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
                              <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save 
                              </button>):
                              (<button className="btn btn-success btn-load">
                                    <span className="d-flex align-items-center">
                                        <span className="spinner-border flex-shrink-0" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </span>
                                        <span className="flex-grow-1 ms-2">
                                            Loading...
                                        </span>
                                    </span>
                                </button>)}
                          </div>
                        </div>
                            
                    </div>
                    </div>
                </div>
                </div>)}
           
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(NewPayroll);
